<template>
  <div class="card">
    <div class="header" @click.prevent="loadData()">
      <h5 v-if="contactData.company">{{contactData.name}} {{ $t('product_show.from') }} {{contactData.company}}</h5>
      <h5 v-else>{{contactData.name}}</h5>
      <p>{{percentage}} {{ $t('product_show.contact.files') }}</p>
      <i class="fa fa-sort-down" v-if="!open"></i>
      <i class="fa fa-sort-up" v-if="open"></i>
    </div>
    <ul v-for="folder in folders" v-if="open">
      <li class="folder-name">
        {{ $t('product_show.contact.folder') }} <a :href="'/folders/' + folder.id + '?contact_id='+ contact.id">{{folder.name}}</a>
      </li>
      <li>
        <ul v-for="doc_types in folder.document_types" :key='doc_types.id'>
          <li>
            <label class="checkbox-container">
              <input type="checkbox" name="item[checked]" :checked="doc_types.checked" disabled>
              <span class="checkmark"></span>
            </label>
          </li>
          <li>{{doc_types.doc_type_name}}</li>
          <li class="file-name">
            <router-link :to="{name: 'record', params: { id: doc_types.file_id }}">
              {{doc_types.file_name}}
            </router-link>
            <div class="exp-status" v-if="doc_types.file_id">
              <span v-if="doc_types.file_status === 'current'">{{ $t('records_list.table.up_to_date') }}</span>
              <span v-else-if="doc_types.file_status === 'soon'" class="soon">{{ $t('records_list.table.expires_soon') }}</span>
              <span v-else-if="doc_types.file_status === 'expired'" class="expired">{{ $t('records_list.table.expired') }}</span>
              <span v-else class="no-expiration">{{ $t('records_list.table.no_expiration') }}</span>
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: ['contact', 'resource'],
    data() {
      return {
        folders: [],
        open: false
      }
    },
    computed: {
      contactData(){
        if (this.$props.resource === "contact") {
          return this.$props.contact || []
        } else {
          return {
            id: this.currentOrg.id,
            name: this.currentUser.full_name,
            company: this.currentOrg.name,
            checked: this.$props.contact.checked,
            total: this.$props.contact.total
          }
        }
      },
      percentage() {
        return (this.contactData.checked / this.contactData.total * 100).toFixed(1) + '%'
      }
    },
    methods: {
      loadData() {
        this.$data.open = !this.$data.open
        this.axios.get(`/products/${this.$route.params.id}/contacts/${this.$props.contact.id}`, {params: {resource: this.$props.resource}}).then((res) => {
          this.$data.folders = res.data
        })
      },
    },
  }
</script>
